import React from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import NoImageFoundDocument from "./noImageFoundDocument";

export default function SlideDocument(props: any) {
  const images = props.data;
  const handleDragStart = (e: any) => e.preventDefault();
  const items = [
    <a href={`${props.data.fileUrl!}/true`} target="_blank">
      <img
        src={props.data.fileUrl!}
        className="uploadImage "
        onDragStart={handleDragStart}
        role="presentation"
      />
    </a>,
  ];
  const captionStyle = {
    fontSize: "2em",
    fontWeight: "bold",
  };

  return (
    <>
      {images[0] !== null ? (
        <div
          className="UploadImageCmp containerSlider"
          style={{ direction: "ltr" }}
        >
          <>
            <Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
              {images?.map((image: any) =>
                image !== undefined && image !== null ? (
                  <>
                    <a
                      href={`${image.fileUrl!}/true`}
                      target="blank"
                      style={{
                        maxWidth: "fit-content",
                        display: "inline-block",
                      }}
                    >
                      <img src={image.fileUrl} style={{ height: "14vh" }} />
                    </a>
                  </>
                ) : (
                  <div style={{ height: "14vh" }}>
                    {" "}
                    <NoImageFoundDocument border={"none"} />
                  </div>
                )
              )}
            </Carousel>
          </>
        </div>
      ) : (
        <NoImageFoundDocument />
      )}
    </>
  );
}
